function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.SliderBar = t() : e.SliderBar = t();
}(this, function () {
  return (n = {}, e.m = t = [function (e, t, n) {
    "use strict";

    function r(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function i(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function o(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    n.r(t), n(1);

    var a = function () {
      function e() {
        var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.options = {
          width: "",
          height: "",
          beforeImg: null,
          afterImg: null,
          line: !0,
          lineColor: ""
        }, this.localData = {
          sliderContainer: null,
          sliderWrap: null,
          beforeWrap: null,
          sliderBtn: null,
          marginX: 0
        }, this.isPhone = window.hasOwnProperty("ontouchstart"), this.moveHandler = this.moveHandler.bind(this), this.options = function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? r(n, !0).forEach(function (t) {
              i(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : r(n).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }

          return e;
        }({}, this.options, {}, t), this.el = document.querySelector(t.el), this.init(this.el);
      }

      return function (e, t, n) {
        t && o(e.prototype, t);
      }(e, [{
        key: "addListener",
        value: function value() {
          var e = this.localData.sliderBtn;
          this.isPhone ? (e.ontouchstart = this.startSlide.bind(this), e.ontouchend = this.endSlide.bind(this)) : (e.onmousedown = this.startSlide.bind(this), e.onmouseup = this.endSlide.bind(this));
        }
      }, {
        key: "startSlide",
        value: function value(e) {
          e.preventDefault();
          var t = this.localData.sliderWrap,
              n = this.localData.sliderBtn,
              r = e.touches && e.touches[0] || e;
          this.localData.marginX = r.pageX - n.offsetLeft, this.isPhone ? t.addEventListener("touchmove", this.moveHandler) : t.addEventListener("mousemove", this.moveHandler);
        }
      }, {
        key: "endSlide",
        value: function value() {
          var e = this.localData.sliderWrap;
          this.isPhone ? e.removeEventListener("touchmove", this.moveHandler) : e.removeEventListener("mousemove", this.moveHandler);
        }
      }, {
        key: "moveHandler",
        value: function value(e) {
          var t = this.localData.marginX,
              n = e.touches && e.touches[0] || e;
          this.localData.sliderBtn.style.left = n.pageX - t + "px", this.localData.beforeWrap.style.width = n.pageX - t + "px";
        }
      }, {
        key: "init",
        value: function value(e) {
          var t = this.options,
              n = t.beforeImg,
              r = t.afterImg,
              i = t.width,
              o = t.height,
              a = t.line,
              s = t.lineColor;

          if (n && r) {
            e.innerHTML = '\n      <div class="slider-container">\n        <div class="slider-wrap">\n          <div class="before-img">\n            <img src='.concat(n, ' alt="">\n          </div>\n          <img src=').concat(r, ' alt="">\n          <span class="slider-btn"></span>\n        </div>\n      </div>\n    '), this.localData.sliderContainer = e.querySelector(".slider-container"), this.localData.sliderWrap = e.querySelector(".slider-wrap"), this.localData.beforeWrap = e.querySelector(".before-img"), this.localData.sliderBtn = e.querySelector(".slider-btn");
            var l = this.localData,
                c = l.sliderContainer,
                u = l.sliderBtn;
            e.style.cssText = "display: flex;justify-content: center;", c.style.cssText = "width: ".concat(i, "; height: ").concat(o, ";"), a ? s && (u.style.background = s) : u.style.background = "none", this.addListener();
          }
        }
      }]), e;
    }();

    t["default"] = a;
  }, function (e, t, n) {
    var r = n(2);
    "string" == typeof r && (r = [[e.i, r, ""]]);
    n(4)(r, {
      insert: "head",
      singleton: !1
    }), r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".slider-container{display:flex;justify-content:center;align-items:center;overflow:hidden}.slider-container .slider-wrap{position:relative;height:100%}.slider-container .slider-wrap img{display:block;height:100%;user-select:none}.slider-container .slider-wrap .before-img{position:absolute;top:0;left:0;width:50%;height:100%;overflow:hidden}.slider-container .slider-wrap .slider-btn{display:block;width:6px;height:100%;background:rgba(0,0,0,0.5);position:absolute;left:50%;top:0;transform:translateX(-50%);cursor:ew-resize}.slider-container .slider-wrap .slider-btn::after{width:50px;height:50px;background-color:rgba(0,0,0,0.5);position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);content:'< >';color:white;font-size:25px;font-weight:900;text-align:center;line-height:50px;border-radius:50%;box-shadow:0 2px 6px #000;transition:all .3s ease}.slider-container .slider-wrap .slider-btn:hover::after{width:40px;height:40px;font-size:20px;line-height:40px}\n", ""]);
  }, function (e, t, n) {
    "use strict";

    e.exports = function (e) {
      var t = [];
      return t.toString = function () {
        return this.map(function (t) {
          var n = function (e, t) {
            var n = e[1] || "",
                r = e[3];
            if (!r) return n;

            if (t && "function" == typeof btoa) {
              var i = function (e) {
                var t = btoa(unescape(encodeURIComponent(JSON.stringify(e)))),
                    n = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(t);
                return "/*# ".concat(n, " */");
              }(r),
                  o = r.sources.map(function (e) {
                return "/*# sourceURL=".concat(r.sourceRoot).concat(e, " */");
              });

              return [n].concat(o).concat([i]).join("\n");
            }

            return [n].join("\n");
          }(t, e);

          return t[2] ? "@media ".concat(t[2], "{").concat(n, "}") : n;
        }).join("");
      }, t.i = function (e, n) {
        "string" == typeof e && (e = [[null, e, ""]]);

        for (var r = {}, i = 0; i < this.length; i++) {
          var o = this[i][0];
          null != o && (r[o] = !0);
        }

        for (var a = 0; a < e.length; a++) {
          var s = e[a];
          null != s[0] && r[s[0]] || (n && !s[2] ? s[2] = n : n && (s[2] = "(".concat(s[2], ") and (").concat(n, ")")), t.push(s));
        }
      }, t;
    };
  }, function (e, t, n) {
    "use strict";

    var r,
        i,
        o = {},
        a = (i = {}, function (e) {
      if (void 0 === i[e]) {
        var t = document.querySelector(e);
        if (window.HTMLIFrameElement && t instanceof window.HTMLIFrameElement) try {
          t = t.contentDocument.head;
        } catch (e) {
          t = null;
        }
        i[e] = t;
      }

      return i[e];
    });

    function s(e, t) {
      for (var n = [], r = {}, i = 0; i < e.length; i++) {
        var o = e[i],
            a = t.base ? o[0] + t.base : o[0],
            s = {
          css: o[1],
          media: o[2],
          sourceMap: o[3]
        };
        r[a] ? r[a].parts.push(s) : n.push(r[a] = {
          id: a,
          parts: [s]
        });
      }

      return n;
    }

    function l(e, t) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n],
            i = o[r.id],
            a = 0;

        if (i) {
          for (i.refs++; a < i.parts.length; a++) {
            i.parts[a](r.parts[a]);
          }

          for (; a < r.parts.length; a++) {
            i.parts.push(v(r.parts[a], t));
          }
        } else {
          for (var s = []; a < r.parts.length; a++) {
            s.push(v(r.parts[a], t));
          }

          o[r.id] = {
            id: r.id,
            refs: 1,
            parts: s
          };
        }
      }
    }

    function c(e) {
      var t = document.createElement("style");

      if (void 0 === e.attributes.nonce) {
        var r = n.nc;
        r && (e.attributes.nonce = r);
      }

      if (Object.keys(e.attributes).forEach(function (n) {
        t.setAttribute(n, e.attributes[n]);
      }), "function" == typeof e.insert) e.insert(t);else {
        var i = a(e.insert || "head");
        if (!i) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
        i.appendChild(t);
      }
      return t;
    }

    var u,
        d = (u = [], function (e, t) {
      return u[e] = t, u.filter(Boolean).join("\n");
    });

    function f(e, t, n, r) {
      var i = n ? "" : r.css;
      if (e.styleSheet) e.styleSheet.cssText = d(t, i);else {
        var o = document.createTextNode(i),
            a = e.childNodes;
        a[t] && e.removeChild(a[t]), a.length ? e.insertBefore(o, a[t]) : e.appendChild(o);
      }
    }

    var p = null,
        h = 0;

    function v(e, t) {
      var n, r, i;

      if (t.singleton) {
        var o = h++;
        n = p = p || c(t), r = f.bind(null, n, o, !1), i = f.bind(null, n, o, !0);
      } else n = c(t), r = function (e, t, n) {
        var r = n.css,
            i = n.media,
            o = n.sourceMap;
        if (i && e.setAttribute("media", i), o && btoa && (r += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(o)))), " */")), e.styleSheet) e.styleSheet.cssText = r;else {
          for (; e.firstChild;) {
            e.removeChild(e.firstChild);
          }

          e.appendChild(document.createTextNode(r));
        }
      }.bind(null, n, t), i = function i() {
        !function (e) {
          null !== e.parentNode && e.parentNode.removeChild(e);
        }(n);
      };

      return r(e), function (t) {
        if (t) {
          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
          r(e = t);
        } else i();
      };
    }

    e.exports = function (e, t) {
      (t = t || {}).attributes = "object" == _typeof(t.attributes) ? t.attributes : {}, t.singleton || "boolean" == typeof t.singleton || (t.singleton = (void 0 === r && (r = Boolean(window && document && document.all && !window.atob)), r));
      var n = s(e, t);
      return l(n, t), function (e) {
        for (var r = [], i = 0; i < n.length; i++) {
          var a = n[i],
              c = o[a.id];
          c && (c.refs--, r.push(c));
        }

        e && l(s(e, t), t);

        for (var u = 0; u < r.length; u++) {
          var d = r[u];

          if (0 === d.refs) {
            for (var f = 0; f < d.parts.length; f++) {
              d.parts[f]();
            }

            delete o[d.id];
          }
        }
      };
    };
  }], e.c = n, e.d = function (t, n, r) {
    e.o(t, n) || Object.defineProperty(t, n, {
      enumerable: !0,
      get: r
    });
  }, e.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, e.t = function (t, n) {
    if (1 & n && (t = e(t)), 8 & n) return t;
    if (4 & n && "object" == _typeof(t) && t && t.__esModule) return t;
    var r = Object.create(null);
    if (e.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: t
    }), 2 & n && "string" != typeof t) for (var i in t) {
      e.d(r, i, function (e) {
        return t[e];
      }.bind(null, i));
    }
    return r;
  }, e.n = function (t) {
    var n = t && t.__esModule ? function () {
      return t["default"];
    } : function () {
      return t;
    };
    return e.d(n, "a", n), n;
  }, e.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, e.p = "", e(e.s = 0))["default"];

  function e(r) {
    if (n[r]) return n[r].exports;
    var i = n[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return t[r].call(i.exports, i, i.exports, e), i.l = !0, i.exports;
  }

  var t, n;
});